import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { CertificateConfigForm } from "../../../components/reportConfig/form/CertificateConfigForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import { ReportType } from "../../../models/enums/reportType";
import type { Group } from "../../../models/group";
import type { Signature } from "../../../models/signature";
import type { YearContext } from "../../../models/yearContext";
import { report_configurations_path } from "../../../routes";

type JumpCertificateConfigCreateProps = {
  year_contexts: YearContext[];
  groups: Group[];
  signatures: Signature[];
};

export default function JumpCertificateConfigCreate({ year_contexts, groups, signatures }: JumpCertificateConfigCreateProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.post(pathWithYearContext(report_configurations_path), values);

  return (
    <ContentShell title="Neue JUMPStart Zertifikat-Vorlage" onBack={() => router.get(pathWithYearContext(report_configurations_path))}>
      <CertificateConfigForm
        signatures={signatures}
        yearContexts={year_contexts}
        groups={groups}
        saveButtonLabel="Erstellen"
        onSubmit={onSubmit}
        reportType={ReportType.JUMP}
      />
    </ContentShell>
  );
}
